module.exports = __webpack_public_path__ + "img/kankou_4.48091a0e.jpg";